import React, { useEffect, useState } from "react";
import DCClogo from "../../assets/img/DCC-Logo.svg";
import Logo_786 from "../../assets/786.png";
import moment from "moment";
import Config from "../../config";
import apiClient from "../../utils/apiClient"; // adjust path to where your apiClient lives

const ReportHeader: React.FC<any> = ({ title, DatePattern }) => {
  const [logoBase64, setLogoBase64] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;
    const originalUrl = Config?.logoUrl;

    if (!originalUrl) {
      console.warn("ReportHeader: Config.logoUrl is missing", Config);
      return;
    }

    // Already base64 or local asset — use directly
    if (originalUrl.startsWith("data:")) {
      setLogoBase64(originalUrl);
      return;
    }

    // If your apiClient baseURL already ends with /api, use /reports/proxy-logo
    // If baseURL is just the domain, use /api/reports/proxy-logo
    const proxyPath = `/report/proxy-logo?url=${encodeURIComponent(originalUrl)}`;

    apiClient
      .get(proxyPath, { responseType: "blob" })
      .then((response) => {
        const blob = response.data as Blob;
        return new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result as string);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      })
      .then((base64) => {
        if (isMounted) setLogoBase64(base64);
      })
      .catch((err) => {
        console.error("ReportHeader: Logo proxy/base64 failed:", err);
      });

    return () => {
      isMounted = false;
    };
  }, [Config?.logoUrl]);

  const activeLogo = logoBase64;

  return (
    <div className="htmltoPdfStyle row align-items-center mb-3">
      {/* Left Logo */}
      <div className="col-4 d-flex justify-content-start">
        {activeLogo ? (
          // <img src={activeLogo} alt="Company-Logo" height="85" width="75" />
          <img src={Logo_786} alt="Company-Logo" height="85" width="85" />
        ) : (
          <span className="text-muted" style={{ fontSize: "12px" }}>
            [Logo Unavailable]
          </span>
        )}
      </div>

      {/* Center Title */}
      <div className="col-4 d-flex flex-column align-items-center justify-content-center">
        <h6 className="text-black mt-2 mb-0">{title}</h6>
        {DatePattern && (
          <>
            <hr
              style={{
                margin: "1px",
                height: "1px",
                borderTop: "1px solid",
                width: "60%",
              }}
            />
            <small className="text-black my-0">{DatePattern}</small>
          </>
        )}
      </div>

      {/* Right Logo */}
      <div className="col-4 d-flex flex-column align-items-end justify-content-end">
        <img src={DCClogo} alt="DCC-Logo" height="75" />
        <small className="text-black mt-2 mb-0">Report Date</small>
        <strong style={{ lineHeight: "normal" }}>
          {moment().format("YYYY-MM-DD")}
        </strong>
      </div>
    </div>
  );
};

export default ReportHeader;
